import {useId} from "react";
import {Modal} from "react-bootstrap";
import UpdateJob from "./UpdateJob";
import "./UpdateJobModal.css";

export default function UpdateJobModal({jobId, onClose, onSaved, onJobUpdated, show}) {
    const titleId = useId();

    return (
        <Modal
            aria-labelledby={titleId}
            className="scheduler-update-job-modal"
            centered
            dialogClassName="scheduler-update-job-modal-dialog"
            onClick={(event) => event.stopPropagation()}
            onHide={onClose}
            scrollable
            show={show}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title id={titleId}>Update Job</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                {show && jobId ? (
                    <UpdateJob
                        jobId={jobId}
                        onSaved={onSaved}
                        onJobUpdated={onJobUpdated}
                    />
                ) : null}
            </Modal.Body>
        </Modal>
    );
}
